<template>
  <Layout>
    <div v-if="atccRecord.id">
      <div class="row">
        <div>
          <h4 class="card-title">
            <div class="row">
              <div class="col-10">
                <button type="button" onclick="history.back()" class="btn btn-sm btn-outline-primary mb-3">
                  <i class="bx bx-chevron-left"></i> Back
                </button>
              </div>
              <div class="col-2">
                <button type="button" onclick="" class="btn btn-sm btn-outline-danger mb-3">
                  Convert to Accident <i class="bx bx-chevron-right"></i>
                </button>
              </div>
            </div>
          </h4>
          <div class="row">
            <div class="col-6">
              <div class="card">
                <div class="card-body">
                  <h4 class="card-title">
                    Transaction Details
                  </h4>
                  <hr />
                  <div class="table-responsive">
                    <table class="table mb-0">
                      <tbody>
                        <tr>
                          <th scope="row">Plate No: </th>
                          <td>{{ atccRecord.plate_no }}
                          </td>
                        </tr>
                        <tr>
                          <th scope="row">Class</th>
                          <td>
                            {{ vehicleClassName }}
                          </td>
                        </tr>
                        <tr>
                          <th scope="row">Speed</th>
                          <td>
                            {{ atccRecord.vehicle_speed > 0 ? atccRecord.vehicle_speed + ' km/hr' : 'NA' }}
                          </td>
                        </tr>
                        <tr>
                          <th scope="row">Confidence</th>
                          <td>
                            {{ `${(atccRecord.confidence * 100).toFixed(0)}%` }}
                          </td>
                        </tr>
                        <tr>
                          <th scope="row">Location</th>
                          <td>{{ atccRecord.location }}
                          </td>
                        </tr>
                        <tr>
                          <th scope="row">Location Code</th>
                          <td>{{ atccRecord.site }}
                          </td>
                        </tr>
                        <tr>
                          <th scope="row">Side</th>
                          <td>{{ atccRecord.side }}</td>
                        </tr>
                        <tr>
                          <th scope="row">Reported Date/Time</th>
                          <td>
                            {{
                              new Date(
                                atccRecord.reported_datetime
                              ).toLocaleString()
                            }}
                          </td>
                        </tr>
                        <tr>
                          <th scope="row">Device Transaction ID</th>
                          <td>{{ atccRecord.transaction_id }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div class="card">
                <div class="card-body">
                  <h4 class="card-title">
                    Images
                  </h4>
                  <hr />
                  <div class="text-center" v-if="atccRecord.images.length === 0">
                    <p>No images added</p>
                  </div>

                  <div v-else>
                    <img v-for="(src, index) in atccRecord.images" :key="index" class="float-left image mb-2"
                      @click="() => showCaptiomImg(index, atccRecord.images)" width="150" :src="src"
                      style="margin-right: 10px; cursor: pointer" />
                  </div>
                </div>
              </div>
            </div>
            <div class="col-6">
              <div class="card">
                <div class="card-body">
                  <h4 class="card-title">Vehicle History - {{ atccRecord.plate_no }}</h4>
                  <hr />
                  <div v-if="atccRecord.vehicleHistory.length === 0">
                    <div class="text-center">
                      <p class="p-5">Vehicle details not found</p>
                    </div>
                  </div>
                  <div v-else class="scroll-history">
                    <ul class="verti-timeline list-unstyled">
                      <li class="event-list active" v-for="(vehicle, key) in atccRecord.vehicleHistory" :key="key">
                        <div class="event-timeline-dot mt-3">
                          <i class="bx bx-right-arrow-circle font-size-18"></i>
                        </div>
                        <div class="d-flex">
                          <div class="mt-3 me-3">
                            <h5 class="font-size-14">
                              {{ new Date(
                                vehicle.reported_datetime
                              ).toLocaleString() }}
                              <i class="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2"></i>
                            </h5>
                          </div>
                          <div class="flex-grow-1">
                            <div class="table-responsive">
                              <table class="table mb-0">
                                <tbody>
                                  <tr>
                                    <th scope="row">Location: </th>
                                    <td>{{ vehicle.location }} {{ vehicle.side }} ({{ vehicle.site }})
                                    </td>
                                  </tr>
                                  <tr>
                                    <th scope="row">Speed</th>
                                    <td>
                                      {{
                                        vehicle.vehicle_speed > 0 ? vehicle.vehicle_speed + ' km/hr' : 'NA' }}
                                    </td>
                                  </tr>
                                  <tr>
                                    <th scope="row">Images</th>
                                    <td>
                                      <div class="text-center" v-if="!vehicle.plate_image_url && !vehicle.veh_image_url">
                                        <p>No images added</p>
                                      </div>

                                      <div class="d-flex" v-else>
                                        <img v-for="(src, index) in [vehicle.plate_image_url, vehicle.veh_image_url]"
                                          :key="index" class="image mb-2"
                                          @click="() => showCaptiomImg(index, [vehicle.plate_image_url, vehicle.veh_image_url])"
                                          width="80" :src="src" style="margin-right: 10px; cursor: pointer" />
                                      </div>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <vue-easy-lightbox :visible="visibleCaption" :imgs="lightBoxImages" :index="index"
        @hide="handleCaptionHide"></vue-easy-lightbox>
    </div>
    <div v-else>
      <widgetLoader></widgetLoader>
    </div>
  </Layout>
</template>

<script>
import Layout from "@/layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import atccMixin from "../../mixins/atcc";
import VueEasyLightbox from "vue-easy-lightbox";
import widgetLoader from "@/components/widgets/widget-loader";
import config from "../../constants/config";

/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Vehicle Details",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },

  mixins: [atccMixin],
  props: {
    incidentId: String,
  },

  components: {
    Layout,
    PageHeader,
    VueEasyLightbox,
    widgetLoader
  },

  data() {
    return {
      atccRecord: {},
      lightBoxImages: [],
      visibleCaption: false,
      index: 1,
      vehicleNumber: null,
      items: [],
      selectedVehicle: {},
      vehicleClass: null,
      config: config,
      options: {
        vehicleClass: [],
        offenceId: [],
        districtCode: [],
        stateCode: [],
        dpCd: [{ name: "TD" }, { name: "TR" }],
        violationSrc: [{ name: "SLV" }, { name: "RLV" }],
        subCategory: [],
        informedTo: [],
      },
      fields: [
        {
          key: "driver_name",
          label: "Driver Name",
          sortable: true,
        },
        {
          key: "vehicle_no",
          label: "Vehicle No.",
          sortable: false,
        },
        {
          key: "mobile_no",
          label: "Mobile No.",
          sortable: false,
        },
        {
          key: "passenger_count",
          label: "No. of Passengers",
          sortable: false,
        },
        {
          key: "driver_address",
          label: "Driver Address",
          sortable: false,
        },
        {
          key: "actions",
        },
      ],
    };
  },

  methods: {
    async onInput(e) {
      this.vehicleNumber = await e.target.innerText;
    },

    showCaptiomImg(index, images) {
      this.lightBoxImages = images
      this.index = index;
      this.visibleCaption = true;
    },

    handleCaptionHide() {
      this.visibleCaption = false;
    },

    getReadableDateTime(dateTime) {
      if (dateTime) {
        return `${new Date(dateTime).toLocaleString()}`;
      }
    },
  },

  computed: {
    masters() {
      return this.$store.getters["incident/masters"];
    },
    vehicleImages() {
      return this.atccRecord.images
        ? this.atccRecord.images.map((e) => e.media_url)
        : [];
    },
    vehicleClassName() {
      return this.masters.vehicleClass && this.atccRecord.class_id ? this.masters.vehicleClass.find(s => s.id == this.atccRecord.class_id).class_name : 'NA'
    },
  },
  async created() {
    this.atccRecord = await this.GetATCCRecordByID(
      this.incidentId
    );
    this.atccRecord['images'] = [this.atccRecord.plate_image_url, this.atccRecord.veh_image_url]
  },
};
</script>

<style scoped>
.scroll-history {
  height: 402px;
  overflow: auto;
}
</style>